import React from 'react';
import {browserHistory} from 'react-router';
import { User } from 'api';
import cookie from 'react-cookie';

class AutoLogin extends React.Component {

  componentDidMount() {
    if (!this.props.location.query.token) {
      browserHistory.push('/');
    } else {
      let expiresParams = {path: '/'};
      cookie.save('accessToken', this.props.location.query.token, expiresParams);
    }
    this.handleLogin();
  }
  handleLogin() {
    User.actions.getInfoFromToken.request().then(res => {
      if (res && res.data) {
        localStorage.clear();
        let userData = {
          id: res.data.congChucId,
          name: res.data.hoVaTen,
          tenVaiTro: res.data.tenVaiTro,
          coQuanQuanLyId: res.data.coQuanQuanLyId,
          vaiTroMacDinhId: res.data.vaiTroMacDinhId,
          loaiVaiTroMacDinh: res.data.loaiVaiTroMacDinh,
          roles: [],
          quyenBatDauQuyTrinh: res.data.quyenBatDauQuyTrinh,
          donViId: res.data.donViId,
          tenCoQuanQuanLy: res.data.tenCoQuanQuanLy,
          capCoQuanQuanLyId: res.data.capCoQuanQuanLyId,
          capCoQuanQuanLyCuaDonViId: res.data.capCoQuanQuanLyCuaDonViId,
          isBoSungThongTin: res.data.isBoSungThongTin
        }
        res.data.roles.map((item, i) => {
          userData.roles.push({
            loaiVaiTro: item.loaiVaiTro,
            vaiTroId: item.vaiTroId,
            ten: item.ten,
            quyen: item.quyen
          });
        });
        let expiresParams = {path: '/'};
        cookie.save('accessToken', res.data.token, expiresParams);
        localStorage.setItem('userInfo', JSON.stringify(userData));
        browserHistory.push('/');
      }
    }).catch(error => {
      cookie.remove('accessToken', {path: '/'});
      browserHistory.push('/');
    });
  }
  render() {
    return (
      <div>
      </div>
    );
  }
}

export default AutoLogin;



// WEBPACK FOOTER //
// ./src/components/modules/login/AutoLogin.jsx